<div
  #odometerEl
  class="mg-odometer"></div>
